import { Component, Prop, Vue } from "vue-property-decorator";
import { DOCUMENT } from "../../constants/DocumentConstants";
import Vuetify from "vuetify";

Vue.use(Vuetify);

@Component({
  name: "EventDocumentData"
})
export default class EventDocumentData extends Vue {
  @Prop({ default: "" })
  private type!: string;
  @Prop({ default: "" })
  private category!: string;
  @Prop({ default: "" })
  private subCategory!: string;

  DOCUMENT_LABELS = DOCUMENT;
}
